import React, { useState, useEffect } from 'react';
import {
	TextField,
	// Button,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	SelectChangeEvent,
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import Grid from '@mui/material/Grid2';

interface ProductEnquiryProps {
	_id: string;
	name: string;
	email: string;
	mobile: string;
	status: number;
	followupStatus: string;
	requirements: string;
	createdAt: string;
	updatedAt: string;
}
interface CreateContactsProps {
	product: ProductEnquiryProps | null;
	onSubmit: (formData: ProductEnquiryProps) => Promise<void>;
	isDisabled: boolean; // Add the isDisabled prop
}

const EditProductEnquriy: React.FC<CreateContactsProps> = ({ product, onSubmit, isDisabled }) => {
	const [formData, setFormData] = useState<ProductEnquiryProps>({
		_id: '',
		name: '',
		email: '',
		mobile: '',
		requirements: '',
		status: 0,
		followupStatus: '',
		createdAt: '',
		updatedAt: '',
	});

	const [isOtherSelected, setIsOtherSelected] = useState(false);
	const [otherFollowupStatus, setOtherFollowupStatus] = useState('');

	const predefinedOptions = [
		'New',
		'Under Review',
		'Awaiting Supplier',
		'Quotation Sent',
		'Follow-up Pending',
		'Confirmed',
		'Closed',
		'Cancelled',
		'Other',
	];

	useEffect(() => {
		if (product) {
			setFormData(product);
			setIsOtherSelected(!predefinedOptions.includes(product.followupStatus));
			setOtherFollowupStatus(
				!predefinedOptions.includes(product.followupStatus) ? product.followupStatus : ''
			);
		}
	}, [product]);

	const handleChange = (
		e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>
	) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({ ...prevData, [name as string]: value }));
	};

	const handleFollowupStatusChange = (event: SelectChangeEvent<string>) => {
		const value = event.target.value as string;
		setFormData((prevData) => ({ ...prevData, followupStatus: value }));
		setIsOtherSelected(value === 'Other');
	};

	const handleOtherFollowupStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setOtherFollowupStatus(value);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		try {
			const finalFormData = {
				...formData,
				followupStatus: isOtherSelected ? otherFollowupStatus : formData.followupStatus,
			};
			await onSubmit(finalFormData);
		} catch (error) {
			console.error('Error submitting form:', error);
		}
	};

	return (
		<form id="create-contact-form" onSubmit={handleSubmit}>
			<Grid container spacing={2}>
				<Grid size={{ xs: 12 }} sx={{ marginTop: '10px' }}>
					<TextField
						label="Name"
						name="name"
						value={formData.name}
						onChange={handleChange}
						fullWidth
						size="small"
						disabled={isDisabled} // Disable the field
					/>
				</Grid>
				<Grid size={{ xs: 12 }}>
					<TextField
						label="Email"
						name="email"
						value={formData.email}
						onChange={handleChange}
						fullWidth
						size="small"
						disabled={isDisabled} // Disable the field
					/>
				</Grid>
				<Grid size={{ xs: 12 }}>
					<TextField
						label="Mobile"
						name="mobile"
						type="text"
						value={formData.mobile}
						onChange={handleChange}
						fullWidth
						size="small"
						slotProps={{
							htmlInput: {
								maxLength: 10,
								// pattern: '[0-9]{10}', // Ensures exactly 10 digits
								onInput: (event: React.ChangeEvent<HTMLInputElement>) => {
									// Cast event.target to HTMLInputElement
									const input = event.target as HTMLInputElement;
									// Restrict input to numeric characters only
									input.value = input.value.replace(/[^0-9]/g, '');
								},
							},
						}}
						disabled={isDisabled} // Disable the field
					/>
				</Grid>
				<Grid size={{ xs: 12 }}>
					<TextField
						label="Requirements"
						name="requirements"
						value={formData.requirements}
						onChange={handleChange}
						fullWidth
						size="small"
						disabled={isDisabled} // Disable the field
					/>
				</Grid>
				<Grid size={{ xs: 12 }}>
					<FormControl fullWidth size="small">
						<InputLabel>Follow-up Status</InputLabel>
						<Select
							name="followupStatus"
							value={isOtherSelected ? 'Other' : formData.followupStatus}
							onChange={handleFollowupStatusChange}
							label="Follow-up Status"
							disabled={isDisabled} // Disable the field
						>
							{predefinedOptions.map((option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Grid>
				{isOtherSelected && (
					<Grid size={{ xs: 12 }}>
						<TextField
							label="Other Follow-up Status"
							name="otherFollowupStatus"
							value={otherFollowupStatus}
							onChange={handleOtherFollowupStatusChange}
							fullWidth
							size="small"
							disabled={isDisabled} // Disable the field
						/>
					</Grid>
				)}
			</Grid>
		</form>
	);
};

export default EditProductEnquriy;
